<div class="min-h-screen bg-gray-50 dark:bg-gray-950">
  <p-toast
    position="top-right"
    [baseZIndex]="9999"
    [breakpoints]="{
      '640px': { width: 'calc(100vw - 2rem)', right: '1rem', left: '1rem', top: '1rem' },
    }"
  />
  <app-sidebar></app-sidebar>
  <app-bottom-nav></app-bottom-nav>

  <!-- Main content -->
  <div
    class="transition-all duration-300 ease-in-out"
    [class.lg:pl-64]="!isSidebarCollapsed()"
    [class.lg:pl-20]="isSidebarCollapsed()"
  >
    <app-header></app-header>

    @if (subscriptionDaysLeft !== null) {
      <div class="px-4 pt-4 sm:px-6 lg:px-8">
        <div
          class="rounded-lg border border-yellow-300 bg-yellow-50 px-4 py-3 text-sm font-medium text-yellow-900 dark:border-yellow-700 dark:bg-yellow-900/25 dark:text-yellow-100"
        >
          @if (subscriptionDaysLeft === 0) {
            {{ 'SHELL.SUBSCRIPTION_WARNING_TODAY' | translate }}
          } @else {
            {{ 'SHELL.SUBSCRIPTION_WARNING_DAYS' | translate: { count: subscriptionDaysLeft } }}
          }
        </div>
      </div>
    }

    <!-- Page content — pb-24 on mobile reserves space for the bottom nav -->
    <main class="p-4 pb-24 sm:p-6 sm:pb-24 lg:p-8 lg:pb-8">
      <router-outlet></router-outlet>
    </main>
  </div>
</div>
